import { render, staticRenderFns } from "./SkinSetting.vue?vue&type=template&id=54d05db9&scoped=true&"
import script from "./SkinSetting.vue?vue&type=script&lang=js&"
export * from "./SkinSetting.vue?vue&type=script&lang=js&"
import style0 from "./SkinSetting.vue?vue&type=style&index=0&id=54d05db9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d05db9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54d05db9')) {
      api.createRecord('54d05db9', component.options)
    } else {
      api.reload('54d05db9', component.options)
    }
    module.hot.accept("./SkinSetting.vue?vue&type=template&id=54d05db9&scoped=true&", function () {
      api.rerender('54d05db9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/SettingChildred/SkinSetting.vue"
export default component.exports